import { render, staticRenderFns } from "./WhereToBuyTable.vue?vue&type=template&id=90e1b18e&scoped=true&"
import script from "./WhereToBuyTable.vue?vue&type=script&lang=js&"
export * from "./WhereToBuyTable.vue?vue&type=script&lang=js&"
import style0 from "./WhereToBuyTable.vue?vue&type=style&index=0&id=90e1b18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e1b18e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
